export default __webpack_public_path__ + "static/media/clear.5e0b8e9a.svg";